// angular
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

// addons
import { map, take } from 'rxjs/operators';

// store
import { Store, select } from '@ngrx/store';
import * as fromStore from '@store/index';

// models
import { IUser, UserRolesEnum, OrganizationStatusEnum } from '@shared/models';

@Injectable()
export class InitiateGuard implements CanActivate {
  constructor(
    private router: Router,
    private store: Store<fromStore.State>
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.store.pipe(
      select(fromStore.UserSelectors.getInfo),
      take(1),
      map((user: IUser) => {
        const isInvestor = user.role === UserRolesEnum.Investor;
        const isOrgNotInitalized = user.organizationStatus === OrganizationStatusEnum.NotInitialized;

        if (isInvestor && isOrgNotInitalized) { return true; }

        this.router.navigate(['/']);

        return false;
      })
    );
  }
}
